import { dataLayerContext, dataLayerContextType } from "@/contexts/context.datalayer";
import { derivedContext, derivedContextType } from "@/contexts/context.derived";
import { optionContext, optionContextType } from "@/contexts/context.option";
import { productContext, productContextType } from "@/contexts/context.product";
import { storeContext, storeContextType } from "@/contexts/context.store";
import { provide } from "@lit/context";
import { property } from "lit/decorators.js";
import { StateNode } from "./node.state";

export class RootNode extends StateNode {
  /**
   * Consumes store provided by root node
   */
  @provide({ context: storeContext  })
  @property({ attribute: false })
  store?: storeContextType;

  @provide({ context: dataLayerContext })
  @property({ attribute: false })
  dataLayer?: dataLayerContextType;

  // Provide a default answer for optionContext at the root so
  // consumers always receive a value (Promise<null>) even when
  // not inside a <bd-option> subtree. A closer provider overrides it.
  @provide({ context: optionContext })
  @property({ attribute: false })
  _optionContextDefault?: optionContextType = Promise.resolve(null);

  // Provide a default product context so binders receive a value
  // even outside a <bd-product> subtree (overridden by closer provider).
  @provide({ context: productContext })
  @property({ attribute: false })
  _productContextDefault?: productContextType = null;

  // Provide user-defined derived variables/functions for Eta + DSL
  @provide({ context: derivedContext })
  @property({ attribute: false })
  derived?: derivedContextType | null = null;
}
